import React, {useMemo} from 'react';
import {MAPBOX_TOKEN} from "../Map/mapBlock";
import Map, {Source, Layer,Marker} from 'react-map-gl';
import {
    continentLayer,
    highlightContinentLayer,
    highlightContinentLayer2,
} from "../../map-styles";
import europe from "../../maps/europe.json";
import asia from "../../maps/asia.json";
import america from "../../maps/north-america.json";
import africa from "../../maps/Africa.json";
import Pin from "../Map/pin";
import {ICoordinate} from "../../types/types";


const continentsMapsList: {[key: string]: any} = {
    europe,
    asia,
    america,
    africa,

}
const MapSideBar = ({hoverInfo,country,continentMap,coordinate}:
   {hoverInfo: string,country: string,continentMap: null | string,coordinate:ICoordinate}) => {

    const selectedCounty = (hoverInfo && country) || '';
    const filter = useMemo(() => ['in', 'name', selectedCounty], [selectedCounty]);
    const pinsCountry = useMemo(() => (
                <Marker
                    key={`marker-country`}
                    longitude={coordinate?.name  !== undefined ? coordinate?.longitude as number : 0}
                    latitude={coordinate?.name !== undefined ? coordinate?.latitude as number : 0}

                    style={{position: 'absolute', top:0}}
                >
                    {coordinate?.name  !== undefined ? <Pin /> : null}

                </Marker>
        ),
        [coordinate?.longitude,coordinate?.latitude]
    );
    return (
        <>
            <Map
                longitude={coordinate?.name  !== undefined ? coordinate?.longitude as number : 0}
                latitude={coordinate?.name !== undefined ? coordinate?.latitude as number : 0}
                zoom={2.5}
                mapStyle="mapbox://styles/kulibab/cl3wvu2g0002i14s4qyjmd44d"
                mapboxAccessToken={MAPBOX_TOKEN}
                >
                {pinsCountry}
                <Source id={'321'} type="geojson" data={continentsMapsList[continentMap as string] as any}>
                    <Layer beforeId="waterway-label" {...continentLayer} />
                    <Layer {...highlightContinentLayer} filter={filter}/>
                    <Layer {...highlightContinentLayer2} filter={filter}/>
                </Source>
            </Map>
            
            </>
    );
};

export default MapSideBar;